import type { SmartFieldResourceListBffResponseApi } from '@ingenico/api-sdk-configuration-private';
import type { SmartFieldsListMappedResponse } from '../../models/smartFields.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapSmartFieldsList(response: SmartFieldResourceListBffResponseApi): SmartFieldsListMappedResponse {
  return {
    pagination: response.pagination,
    data: response.data.map(
      ({ id, name, description, dataType, defaultValue, creationDate, createdBy, uiComponent, categories }) => ({
        createdById: createdBy?.id,
        createdByName: createdBy?.name,
        creationDate: toIsoStringIfDate(creationDate),
        description,
        id,
        name,
        dataType,
        defaultValue,
        uiComponent,
        categories,
      }),
    ),
  };
}
